var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_553_22638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5998 12.8002H4.7998V11.2002H5.5998C5.81198 11.2002 6.01546 11.2845 6.16549 11.4345C6.31552 11.5845 6.3998 11.788 6.3998 12.0002C6.3998 12.2124 6.31552 12.4159 6.16549 12.5659C6.01546 12.7159 5.81198 12.8002 5.5998 12.8002ZM11.1998 16.0002V11.2002H11.9998C12.212 11.2002 12.4155 11.2845 12.5655 11.4345C12.7155 11.5845 12.7998 11.788 12.7998 12.0002V15.2002C12.7998 15.4124 12.7155 15.6159 12.5655 15.7659C12.4155 15.9159 12.212 16.0002 11.9998 16.0002H11.1998Z",
    fill: "#FF3535"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6001 2.4C1.6001 1.76348 1.85295 1.15303 2.30304 0.702944C2.75313 0.252856 3.36358 0 4.0001 0L17.1313 0L22.4001 5.2688V21.6C22.4001 22.2365 22.1472 22.847 21.6972 23.2971C21.2471 23.7471 20.6366 24 20.0001 24H4.0001C3.36358 24 2.75313 23.7471 2.30304 23.2971C1.85295 22.847 1.6001 22.2365 1.6001 21.6V2.4ZM5.6001 9.6H3.2001V17.6H4.8001V14.4H5.6001C6.23662 14.4 6.84707 14.1471 7.29715 13.6971C7.74724 13.247 8.0001 12.6365 8.0001 12C8.0001 11.3635 7.74724 10.753 7.29715 10.3029C6.84707 9.85286 6.23662 9.6 5.6001 9.6ZM12.0001 9.6H9.6001V17.6H12.0001C12.6366 17.6 13.2471 17.3471 13.6972 16.8971C14.1472 16.447 14.4001 15.8365 14.4001 15.2V12C14.4001 11.3635 14.1472 10.753 13.6972 10.3029C13.2471 9.85286 12.6366 9.6 12.0001 9.6ZM16.0001 17.6V9.6H20.8001V11.2H17.6001V12.8H19.2001V14.4H17.6001V17.6H16.0001Z",
    fill: "#FF3535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_553_22638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf2);
export default __webpack_public_path__ + "static/media/PDF2.cab1af3614805717a964e5b7731e52c1.svg";
export { ForwardRef as ReactComponent };